import styled from '@emotion/styled'
import { Button, ButtonProps } from '@mui/material'
import { convertToPixelFromVW } from '../../utils/ViewportUtils'

const DataSourceButton = styled(Button)<{ radius?: number, background?: string } & ButtonProps>(({ radius, background }) => ({
    fontWeight: 700,
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    justifyItems: 'start',
    color: 'var(--text-dark)',
    background: background ?? '#F2F8FD',
    textTransform: 'none',
    borderRadius: `${radius}vw`,
    minWidth: '2vw',
    boxShadow: '0px 0px 0.5vw 0px #12AEB5DB inset',
    paddingLeft: '0.5vw',
    paddingRight: '0.5vw',
    '& svg': {
        fontSize: `${convertToPixelFromVW(1.25)}`,
        marginRight: 1,
    }
}))

export default DataSourceButton